export enum IEntertainmentNotificationType {
  entertainment_request = "entertainment_request",
  adventure_request = "adventure_request",
  ANNOUNCMENTS = "ANNOUNCMENTS",
}

export enum IEntertainmentNotificationEvent {
  ANNOUNCMENT_CREATED = "ANNOUNCMENT_CREATED",
  created = "created",
  canceled = "canceled",
  accepted = "accepted",
  rejected = "rejected",
}
